import React, { useState, useEffect, useRef } from "react";
import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	Button,
	Switch,
	Grid,
	Box,
	FormControlLabel,
	DialogContent,
	DialogContentText,
	IconButton,
	TableFooter,
	Divider,
	TextField,
	FormControl,
} from "@material-ui/core";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import { CSVLink } from "react-csv";
import { Modal } from "antd";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import moment from "moment";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import HttpService from "../../services/httpService";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TablePagination from "@material-ui/core/TablePagination";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import PropTypes from "prop-types";
import DetailsModalOfInwarding from "../../components/DetailsModalOfInwarding";

const useStyles = makeStyles((theme) => ({
	root: {
		flexShrink: 0,
		marginLeft: theme.spacing(2.5),
	},
	table: {
		minWidth: 850,
	},
	textField: {
		width: 100,
	},
	paper: {
		padding: theme.spacing(2),
		margin: "auto",
		maxWidth: 400,
	},
	actionButton: {
		backgroundColor: "#F47E46", // Primary background color
		color: "#FFF2EB", // Primary text color
		"&:hover": {
			backgroundColor: "#E36F3E", // Darkened version of #F47E46
			color: "#FFD9C7", // Lightened version of #FFF2EB
		},
	},
	submitButton: {
		backgroundColor: "#F47E46 !important", // Decorpot Orange
		color: "white", // White text
		"&:hover": {
			backgroundColor: "#E0663D !important", // Darker Orange on hover
		},
	},
	clearButton: {
		backgroundColor: "#FFF2EB !important", // Light Beige
		color: "#1C375D !important", // Decorpot Orange text
		"&:hover": {
			backgroundColor: "#E7BAD0 !important", // Light Pink on hover
		},
	},
	positiveChange: {
		fontWeight: "bold",
		color: "green",
	},
	negativeChange: {
		fontWeight: "bold",
		color: "red",
	},
}));

// /masterManagement/material-price-change-details
// MaterialPriceChangeDetails

const StyledTableCell = withStyles((theme) => ({
	head: {
		backgroundColor: "#1C375D",
		color: "#FFF2EB",
		fontWeight: "500",
	},
	body: {
		fontSize: 14,
		// border: '1px solid red'
	},
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
	root: {
		"&:nth-of-type(odd)": {
			backgroundColor: theme.palette.action.hover,
		},
	},
}))(TableRow);

function TablePaginationActions(props) {
	const classes = useStyles();
	const theme = useTheme();
	const { count, page, rowsPerPage, onPageChange } = props;

	const handleFirstPageButtonClick = (event) => {
		onPageChange(event, 0);
	};

	const handleBackButtonClick = (event) => {
		onPageChange(event, page - 1);
	};

	const handleNextButtonClick = (event) => {
		onPageChange(event, page + 1);
	};

	const handleLastPageButtonClick = (event) => {
		onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
	};

	return (
		<div className={classes.root}>
			<IconButton
				onClick={handleFirstPageButtonClick}
				disabled={page === 0}
				aria-label="first page"
			>
				{theme.direction === "rtl" ? (
					<LastPageIcon />
				) : (
					<FirstPageIcon />
				)}
			</IconButton>
			<IconButton
				onClick={handleBackButtonClick}
				disabled={page === 0}
				aria-label="previous page"
			>
				{theme.direction === "rtl" ? (
					<KeyboardArrowRight />
				) : (
					<KeyboardArrowLeft />
				)}
			</IconButton>
			<IconButton
				onClick={handleNextButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="next page"
			>
				{theme.direction === "rtl" ? (
					<KeyboardArrowLeft />
				) : (
					<KeyboardArrowRight />
				)}
			</IconButton>
			<IconButton
				onClick={handleLastPageButtonClick}
				disabled={page >= Math.ceil(count / rowsPerPage) - 1}
				aria-label="last page"
			>
				{theme.direction === "rtl" ? (
					<FirstPageIcon />
				) : (
					<LastPageIcon />
				)}
			</IconButton>
		</div>
	);
}

TablePaginationActions.propTypes = {
	count: PropTypes.number.isRequired,
	onPageChange: PropTypes.func.isRequired,
	page: PropTypes.number.isRequired,
	rowsPerPage: PropTypes.number.isRequired,
};

const MaterialPriceChangeDetails = (props) => {
	const classes = useStyles();
	const [materialPriceChangeLogs, setMaterialPriceChangeLogs] = useState([]);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalRowCount, setTotalRowCount] = useState(0);
	const [csvData, setCsvData] = useState([]);
	const [startDate, setStartDate] = useState("");
	const [endDate, setEndDate] = useState("");
	const [selectedVendor, setSelectedVendor] = useState("");
	const [poSoMaterials, setPoSoMaterials] = useState(false);
	const [vendorList, setVendorList] = useState([]);
	const [materialList, setMaterialList] = useState([]);
	const [selectedMaterial, setSelectedMaterial] = useState("");

	const csvButtonRef = useRef(null);

	// Headers to for csv
	const headers = [
		{ key: "materialName", label: "Material Name" },
		{ key: "vendorName", label: "Vendor Name" },
		{ key: "rateCardCode", label: "Rate Card Code" },
		{ key: "previousPrice", label: "Old Rate" },
		{ key: "newPrice", label: "New Rate" },
		{ key: "priceChangeDiff", label: "Change In Rate" },
		{ key: "priceChangePercent", label: "Percent Rate Change" },
		{ key: "changedBy", label: "Changed By" },
		{ key: "changedAt", label: "Changed At" },
	];

	// function to download data in csv
	const csvDownloadHandler = async () => {
		setLoading(true);
		try {
			let csvArray = [];

			for (let i = 0; i < materialPriceChangeLogs.length; i++) {
				let obj = {
					materialName:
						materialPriceChangeLogs[i]?.materialId?.name || "N/A",
					vendorName:
						materialPriceChangeLogs[i]?.vendorId?.name || "N/A",
					rateCardCode:
						materialPriceChangeLogs[i]?.orgRateCardId?.rateCardMasterId?.rateCardCode || "N/A",
					previousPrice:
						materialPriceChangeLogs[i]?.previousPrice || "N/A",
					newPrice: materialPriceChangeLogs[i]?.newPrice || "N/A",
					priceChangeDiff:
						materialPriceChangeLogs[i]?.priceChangeDiff,
					priceChangePercent:
						materialPriceChangeLogs[i]?.priceChangePercent,
					changedBy:
						materialPriceChangeLogs[i]?.changedBy?.name || "N/A",
					changedAt: dateFormatter(
						materialPriceChangeLogs[i]?.changedAt || ""
					),
				};
				csvArray.push(obj);
			}
			setCsvData(csvArray);
			downloadExcel();
		} catch (error) {
			console.error("error", error);
			props?.setSnackInfo(
				error?.response?.data?.message ?? "Something went wrong",
				"error"
			);
		}
		setLoading(false);
	};

	// a helper function for csv download
	const downloadExcel = () => {
		setLoading(true);
		try {
			setTimeout(() => {
				csvButtonRef.current.link.click();
			});
		} catch (err) {
			console.error(err.message);
		}
		setLoading(false);
	};

	// function to format date
	const dateFormatter = (inputDate) => {
		if (inputDate === "") return "N/A";
		const date = new Date(inputDate);
		const day = date.getDate();
		const month = date.getMonth() + 1;
		const year = date.getFullYear();

		const formattedDay = day < 10 ? "0" + day : day;
		const formattedMonth = month < 10 ? "0" + month : month;

		const formattedDate = formattedDay + "-" + formattedMonth + "-" + year;
		return formattedDate;
	};

	// filter function for date range
	const filterLogsOnSelectedDate = () => {
		props.setLoading(true);
		if (startDate && endDate) {
			fetchMaterialPriceChangeLogs(startDate, endDate, "", "", poSoMaterials);
		}
		props.setLoading(false);
	};

	// function to clear date filter
	const clearFilterDate = (e) => {
		props.setLoading(true);
		setStartDate("");
		setEndDate("");
		// setDataToDisplay(dataForNewInwardingApproval);
		fetchMaterialPriceChangeLogs("", "", "", "", poSoMaterials);
		setSelectedVendor("");
		setSelectedMaterial("");
		props.setLoading(false);
	};

	// function to handle vendor select
	const handleVendorChange = async (event, value) => {
		try {
			setSelectedVendor(value);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo("Something Went Wrong", "error");
		}
	};

	// function to handle vendor select
	const handleMaterialChange = async (event, value) => {
		try {
			setSelectedMaterial(value);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo("Something Went Wrong", "error");
		}
	};

	// function to handle materila type
	const handleSwitchPoSoQuotation = async (event, value) => {
		try {
			setPoSoMaterials((prevState) => !prevState);
			setSelectedVendor("");
			setSelectedMaterial("");
			setStartDate("");
			setEndDate("");
			fetchMaterialPriceChangeLogs("", "", "", "", !poSoMaterials);
			fetchAllMaterialList(!poSoMaterials);
			fetchAllVendorHandler(!poSoMaterials);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo("Something Went Wrong", "error");
		}
	};

	// fucntion to get all vendor's list
	const fetchAllVendorHandler = async (poSoMaterial) => {
		try {
			const response = await HttpService.getAllVendors();
			if(poSoMaterial){
				setVendorList(response.data);
			}else{
				let vendors = response.data.filter((el) => el.name === "Decorpot - Test Vendor");
				setVendorList(vendors);
			}
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo("Something Went Wrong", "error");
		}
	};

	// fucntion to get all material's list
	const fetchAllMaterialList = async (poSoMaterial) => {
		try {
			let response;
			if(poSoMaterial){
				response = await HttpService.getAllMaterialsNames();
			}else{
				response = await HttpService.getAllProducts();
			}
			setMaterialList(response.data);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo("Something Went Wrong", "error");
		}
	};

	// fucntion to get material price change logs based on selected vedor
	const searchBasedOnSelectedVendor = async () => {
		try {
			fetchMaterialPriceChangeLogs(
				startDate,
				endDate,
				selectedVendor?._id,
				selectedMaterial?._id,
				poSoMaterials
			);
		} catch (error) {
			console.error("Error -> ", error);
			props.setSnackInfo("Something Went Wrong", "error");
		}
	};

	// Function to handle page change
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	// Function to handle change in rows per page
	const handleChangeRowsPerPage = (event) => {
		if (event.target.value === "All") {
			setRowsPerPage(parseInt(totalRowCount, 10));
		} else {
			setRowsPerPage(parseInt(event.target.value, 10));
		}
		setPage(0);
	};

	// function to get inwarding data sent for inwarding approvals
	const fetchMaterialPriceChangeLogs = async (
		startDate,
		endDate,
		vendorId,
		materialId,
		poSoMaterials
	) => {
		props.setLoading(true);
		try {
			const response = await HttpService.fetchMaterialPriceChangeHistory(
				startDate,
				endDate,
				page,
				rowsPerPage,
				vendorId,
				materialId,
				poSoMaterials
			);
			setMaterialPriceChangeLogs(response.data.data);
			setTotalRowCount(response.data.pagination.totalRecords);
			// setPage(response.data.pagination.currentPage);
			// setDataToDisplay(response.data);
		} catch (err) {
			props.setSnackInfo(
				err?.response?.data ?? "Something went wrong",
				"error"
			);
		}
		props.setLoading(false);
	};

	useEffect(() => {
		fetchAllVendorHandler();
		fetchAllMaterialList();
		fetchMaterialPriceChangeLogs(
			startDate,
			endDate,
			selectedVendor?._id,
			selectedMaterial?._id,
			poSoMaterials
		);
	}, [page, rowsPerPage]);

	return (
		<div>
			<div
				style={{
					marginBottom: 20,
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Paper className={classes.paper}>
					<center>
						<h2>Material Price Change Details</h2>
					</center>
				</Paper>
			</div>
			{/* Component to Switch between PO/SO & Quotation Material */}
			<FormControlLabel
				control={
					<Switch
						checked={poSoMaterials}
						onChange={handleSwitchPoSoQuotation}
						name="multiCheck"
						color="primary"
					/>
				}
				label="Switch To PO/SO Materials"
				className={classes.multiSelect}
			/>

			{/* Vendor And Payment Status Filter component */}
			<Paper style={{ padding: 10, marginBottom: 10 }}>
				<Grid
					container
					style={{ display: "flex", alignItems: "center" }}
				>
					{/* Select Vendor Button */}
					<Autocomplete
						value={selectedVendor}
						onChange={handleVendorChange}
						id="vendor-name-dropdown"
						options={vendorList}
						getOptionLabel={(option) => option.name}
						style={{ width: 500, margin: 10 }}
						renderInput={(params) => (
							<TextField
								{...params}
								label="Vendor Search"
								fullWidth
								variant="outlined"
							/>
						)}
					/>

					{/* Select Material Button */}
					<Autocomplete
						value={selectedMaterial}
						onChange={handleMaterialChange}
						id="material-name-dropdown"
						options={materialList}
						getOptionLabel={(option) => option.name}
						style={{ width: 500, margin: 10 }}
						renderInput={(params) => (
							<TextField
								{...params}
								label="Material Search"
								fullWidth
								variant="outlined"
							/>
						)}
					/>

					{/* Search Button */}
					<Button
						onClick={searchBasedOnSelectedVendor}
						style={{
							margin: 10,
							backgroundColor: "#355025",
							color: "#FFF2EB",
						}}
						variant="contained"
					>
						Search
					</Button>

					{/* Download CSV Button */}
					<div style={{ display: "flex", alignItems: "center" }}>
						<CSVLink
							headers={headers}
							filename={
								"Material Price Change Logs " +
								new Date()
									.toLocaleDateString()
									.replaceAll("/", "_") +
								".csv"
							}
							data={csvData}
							ref={csvButtonRef}
						/>
						<Button
							onClick={csvDownloadHandler}
							style={{
								margin: 10,
								backgroundColor: "#355025",
								color: "#FFF2EB",
							}}
							variant="contained"
						>
							Download CSV
						</Button>
					</div>
				</Grid>
			</Paper>

			{/* Date Filter component */}
			<Paper style={{ padding: 10, marginBottom: 10 }}>
				<Grid
					container
					style={{ display: "flex", alignItems: "center" }}
				>
					<Grid
						item
						md={3}
						xs={12}
					>
						<TextField
							id="date"
							name="startDate"
							label="From"
							type="date"
							value={startDate}
							onChange={(e) => setStartDate(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							fullWidth
							// className={classes.textField}
						/>
					</Grid>
					<Grid
						item
						md={1}
						xs={12}
					></Grid>
					<Grid
						item
						md={3}
						xs={12}
					>
						<TextField
							id="date"
							name="endDate"
							label="To"
							type="date"
							value={endDate}
							onChange={(e) => setEndDate(e.target.value)}
							InputLabelProps={{
								shrink: true,
							}}
							fullWidth
							// className={classes.textField}
						/>
					</Grid>
					<Grid
						item
						md={3}
						xs={12}
					>
						<Button
							variant="contained"
							disabled={!startDate || !endDate}
							onClick={filterLogsOnSelectedDate}
							style={{ marginLeft: 10 }}
							className={
								startDate && endDate
									? classes.submitButton
									: null
							}
						>
							Submit
						</Button>
					</Grid>
					<Grid
						item
						md={2}
						xs={12}
					>
						<Button
							variant="contained"
							onClick={clearFilterDate}
							className={classes.clearButton}
						>
							Clear Filter
						</Button>
					</Grid>
				</Grid>
			</Paper>

			{/* Table for displaying material pricing updates */}
			<TableContainer
				TableContainer
				component={Paper}
			>
				<Table
					className={classes.table}
					size="small"
					aria-label="customized table"
					stickyHeader
				>
					<TableHead>
						<TableRow>
							<StyledTableCell>Sl No</StyledTableCell>
							<StyledTableCell>Material Name</StyledTableCell>
							<StyledTableCell>Vendor Name</StyledTableCell>
							{!poSoMaterials && <StyledTableCell>Rate Card Code</StyledTableCell>}
							<StyledTableCell>Old Rate</StyledTableCell>
							<StyledTableCell>New Rate</StyledTableCell>
							<StyledTableCell>Change in Price</StyledTableCell>
							<StyledTableCell>
								Percent Rate Change
							</StyledTableCell>
							<StyledTableCell>Changed By</StyledTableCell>
							<StyledTableCell>Changed At</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{materialPriceChangeLogs?.map((el, i) => {
							return (
								<StyledTableRow key={i + 1}>
									<StyledTableCell>
										{i + 1 + page * rowsPerPage}
									</StyledTableCell>
									<StyledTableCell>
										{el?.materialId?.name}
									</StyledTableCell>
									<StyledTableCell>
										{el?.vendorId?.name}
									</StyledTableCell>
									{
										!poSoMaterials &&
										<StyledTableCell>
											{el?.orgRateCardId?.rateCardMasterId?.rateCardCode}
										</StyledTableCell>
									}
									<StyledTableCell>
										{el?.previousPrice}
									</StyledTableCell>
									<StyledTableCell>
										{el?.newPrice}
									</StyledTableCell>
									<StyledTableCell
										className={
											+el.priceChangeDiff > 0
												? classes.positiveChange
												: classes.negativeChange
										}
									>
										{el?.priceChangeDiff}
									</StyledTableCell>
									<StyledTableCell
										className={
											+el.priceChangeDiff > 0
												? classes.positiveChange
												: classes.negativeChange
										}
									>
										{el?.priceChangePercent}
									</StyledTableCell>
									<StyledTableCell>
										{el?.changedBy?.name}
									</StyledTableCell>
									<StyledTableCell>
										{moment(el?.changedAt).format(
											"DD-MM-YYYY"
										)}
									</StyledTableCell>
								</StyledTableRow>
							);
						})}
					</TableBody>
				</Table>
				<TableFooter>
					<TableRow>
						<TablePagination
							rowsPerPageOptions={[
								10,
								50,
								100,
								200,
								{
									label: "All",
									value: totalRowCount ? totalRowCount : "",
								},
							]}
							colSpan={8}
							count={totalRowCount}
							rowsPerPage={rowsPerPage}
							page={page}
							SelectProps={{
								inputProps: { "aria-label": "rows per page" },
								native: true,
							}}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							ActionsComponent={TablePaginationActions}
						/>
					</TableRow>
				</TableFooter>
			</TableContainer>
		</div>
	);
};

export default connect(null, { setLoading, setSnackInfo })(
	MaterialPriceChangeDetails
);
